export function isPublicAiPricingContext(quest) {
    if (!quest || quest.private === true) return false
    return quest.public === true || quest.team?.public === true
}
